interface SEOProps {
  title: string;
  description: string;
  canonicalPath?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
  noindex?: boolean;
}

export default function SEO({ title, description, canonicalPath, ogImage, schema, noindex }: SEOProps) {
  const siteUrl = import.meta.env.VITE_SITE_URL || '';
  const canonical = canonicalPath ? `${siteUrl}${canonicalPath}` : undefined;
  const fullTitle = `${title} | PayFlow AI`;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="PayFlow AI" />
      {canonical && <meta property="og:url" content={canonical} />}
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex" />}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </>
  );
}